import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "page page51"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "content",
  style: {
    "width": "100%",
    "position": "absolute",
    "top": "7%",
    "transform": "translateY(-50%)"
  }
};
const _hoisted_5 = ["src"];
const _hoisted_6 = ["src"];
const _hoisted_7 = ["src"];
const _hoisted_8 = ["src"];
const _hoisted_9 = ["src"];
const _hoisted_10 = ["src"];
const _hoisted_11 = ["src"];
const _hoisted_12 = ["src"];
const _hoisted_13 = ["src"];
const _hoisted_14 = ["src"];
const _hoisted_15 = ["src"];
const _hoisted_16 = ["src"];
const _hoisted_17 = ["src"];
const _hoisted_18 = ["src"];
const _hoisted_19 = ["src"];
const _hoisted_20 = ["src"];
const _hoisted_21 = ["src"];
const _hoisted_22 = ["src"];
const _hoisted_23 = ["src"];
const _hoisted_24 = ["src"];
const _hoisted_25 = ["src"];
const _hoisted_26 = ["src"];

// 引入图片
import 场景展示 from '@/assets/v2/page5-1/场景展示.webp';
import 返回首页 from '@/assets/v2/page3/返回首页.webp';
import 图 from '@/assets/v2/page5-1/图.webp';
import wenzi1 from '@/assets/v2/page5-1/文字/wenzi1.webp';
import 竖线1 from '@/assets/v2/page5-1/标识线/竖线1.webp';
import 椭圆黑 from '@/assets/v2/page5-1/标识线/椭圆黑.webp';
import 椭圆白 from '@/assets/v2/page5-1/标识线/椭圆白.webp';
import 烹饪 from '@/assets/v2/page5-1/文字/烹饪.webp';
import 厨房 from '@/assets/v2/page5-1/文字/厨房.webp';
import 深u from '@/assets/v2/page5-1/文字/深u.webp';
import 大冰箱 from '@/assets/v2/page5-1/文字/大冰箱.webp';
import 折线白 from '@/assets/v2/page5-1/标识线/折线白.webp';
import 整体定制橱柜 from '@/assets/v2/page5-1/文字/整体定制橱柜.webp';
import 地砖 from '@/assets/v2/page5-1/文字/地砖.webp';
import 折线黑 from '@/assets/v2/page5-1/标识线/折线黑.webp';
import 移门 from '@/assets/v2/page5-1/文字/移门.webp';
export default {
  __name: 'Page5-1',
  emits: ['goHome'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const gohome = () => {
      emit('goHome');
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("img", {
        src: _unref(场景展示),
        alt: "场景展示",
        class: "场景展示",
        loading: "lazy"
      }, null, 8, _hoisted_2), _createElementVNode("img", {
        src: _unref(返回首页),
        alt: "返回首页",
        class: "gohomeImage",
        onClick: gohome,
        loading: "lazy"
      }, null, 8, _hoisted_3), _createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
        src: _unref(wenzi1),
        alt: "wenzi1",
        class: "wenzi1",
        loading: "lazy"
      }, null, 8, _hoisted_5), _createElementVNode("img", {
        src: _unref(图),
        alt: "图",
        class: "图",
        loading: "lazy"
      }, null, 8, _hoisted_6), _createElementVNode("img", {
        src: _unref(竖线1),
        alt: "竖线1",
        class: "竖线1",
        loading: "lazy"
      }, null, 8, _hoisted_7), _createElementVNode("img", {
        src: _unref(椭圆黑),
        alt: "椭圆黑",
        class: "椭圆黑",
        loading: "lazy"
      }, null, 8, _hoisted_8), _createElementVNode("img", {
        src: _unref(烹饪),
        alt: "烹饪",
        class: "烹饪",
        loading: "lazy"
      }, null, 8, _hoisted_9), _createElementVNode("img", {
        src: _unref(竖线1),
        alt: "竖线2",
        class: "竖线2",
        loading: "lazy"
      }, null, 8, _hoisted_10), _createElementVNode("img", {
        src: _unref(椭圆黑),
        alt: "椭圆黑2",
        class: "椭圆黑2",
        loading: "lazy"
      }, null, 8, _hoisted_11), _createElementVNode("img", {
        src: _unref(厨房),
        alt: "厨房",
        class: "厨房",
        loading: "lazy"
      }, null, 8, _hoisted_12), _createElementVNode("img", {
        src: _unref(深u),
        alt: "深u",
        class: "深u",
        loading: "lazy"
      }, null, 8, _hoisted_13), _createElementVNode("img", {
        src: _unref(竖线1),
        alt: "竖线2",
        class: "竖线3",
        loading: "lazy"
      }, null, 8, _hoisted_14), _createElementVNode("img", {
        src: _unref(椭圆黑),
        alt: "椭圆黑2",
        class: "椭圆黑3",
        loading: "lazy"
      }, null, 8, _hoisted_15), _createElementVNode("img", {
        src: _unref(折线白),
        alt: "折线白",
        class: "折线白",
        loading: "lazy"
      }, null, 8, _hoisted_16), _createElementVNode("img", {
        src: _unref(椭圆白),
        alt: "椭圆白",
        class: "椭圆白",
        loading: "lazy"
      }, null, 8, _hoisted_17), _createElementVNode("img", {
        src: _unref(大冰箱),
        alt: "大冰箱",
        class: "大冰箱",
        loading: "lazy"
      }, null, 8, _hoisted_18), _createElementVNode("img", {
        src: _unref(竖线1),
        alt: "竖线4",
        class: "竖线4",
        loading: "lazy"
      }, null, 8, _hoisted_19), _createElementVNode("img", {
        src: _unref(椭圆黑),
        alt: "椭圆黑4",
        class: "椭圆黑4",
        loading: "lazy"
      }, null, 8, _hoisted_20), _createElementVNode("img", {
        src: _unref(整体定制橱柜),
        alt: "整体定制橱柜",
        class: "整体定制橱柜",
        loading: "lazy"
      }, null, 8, _hoisted_21), _createElementVNode("img", {
        src: _unref(竖线1),
        alt: "竖线5",
        class: "竖线5",
        loading: "lazy"
      }, null, 8, _hoisted_22), _createElementVNode("img", {
        src: _unref(椭圆黑),
        alt: "椭圆黑5",
        class: "椭圆黑5",
        loading: "lazy"
      }, null, 8, _hoisted_23), _createElementVNode("img", {
        src: _unref(地砖),
        alt: "地砖",
        class: "地砖",
        loading: "lazy"
      }, null, 8, _hoisted_24), _createElementVNode("img", {
        src: _unref(折线黑),
        alt: "折线黑",
        class: "折线黑",
        loading: "lazy"
      }, null, 8, _hoisted_25), _createElementVNode("img", {
        src: _unref(移门),
        alt: "移门",
        class: "移门",
        loading: "lazy"
      }, null, 8, _hoisted_26)])]);
    };
  }
};